import React from 'react';
import Text from 'Components/Text';
import moment from 'moment';

export default ({ description, type, category, id, componentTypeFieldValues, submissionDate }) => {
  return (
    <section className='scene_section'>
      <header>General Information</header>
      <Text
        mainWrapperClassName='text__wrapper_primary  _width_pc_100'
        textClassName='text__text_primary'
        label='Component ID'
        value={id}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary  _margin_right_30'
        textClassName='text__text_primary'
        label='Component Category'
        value={category.name}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary'
        textClassName='text__text_primary'
        label='Component Type'
        value={type.componentTypeName}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary _width_pc_100'
        textClassName='text__text_primary'
        label='Submission Date'
        value={submissionDate && moment(submissionDate).format('MM / DD / YYYY')}
      />
      {componentTypeFieldValues.map((field, index) => (
        <Text
          mainWrapperClassName={`text__wrapper_primary ${index % 2 === 0 ? '_margin_right_30' : ''}`}
          textClassName='text__text_primary'
          key={field.componentTypeFieldId}
          label={field.componentTypeFieldName}
          value={field.componentTypeFieldValue}
        />
      ))}
      <Text
        mainWrapperClassName='text__wrapper_primary _width_pc_100'
        textClassName='text__text_primary'
        label='Component Name'
        value={description}
      />
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/Application/Details/GeneralInformation.jsx